"use client";

import React from "react";

import { EmHouseIcon, EmHousesIcon } from "@/components/icons-lib";

import { type IProjectClusterPayload } from "../../map-panel-context";

import { ClusterSelectionList } from "./cluster-selection/cluster-selection-list";
import { ClusterSelectionPanelLayout } from "./cluster-selection/cluster-selection-panel-layout";
import { ClusterSelectionSummary } from "./cluster-selection/cluster-selection-summary";
import { PROJECT_CLUSTER_PANEL_DICTIONARY } from "./project-cluster-summary.constants";

interface ProjectClusterPanelContentProps {
  payload: IProjectClusterPayload | null;
  onProjectSelect: (projectId: string) => void;
}

const ProjectClusterPanelContentComponent: React.FC<ProjectClusterPanelContentProps> =
  React.memo(({ payload, onProjectSelect }) => {
    const projects = payload?.projects ?? [];

    return (
      <ClusterSelectionPanelLayout>
        <ClusterSelectionSummary
          metrics={[
            {
              value: payload?.projectsCount ?? 0,
              label: PROJECT_CLUSTER_PANEL_DICTIONARY.projects,
              icon: <EmHouseIcon />,
            },
            {
              value: payload?.unitsCount ?? 0,
              label: PROJECT_CLUSTER_PANEL_DICTIONARY.units,
              icon: <EmHousesIcon />,
            },
          ]}
        />
        <ClusterSelectionList
          columnHeader={PROJECT_CLUSTER_PANEL_DICTIONARY.projectNameColumn}
          items={projects.map((project) => ({
            id: project.projectId,
            name: project.projectName,
          }))}
          sectionTitle={PROJECT_CLUSTER_PANEL_DICTIONARY.newHousingProjects}
          onItemSelect={onProjectSelect}
        />
      </ClusterSelectionPanelLayout>
    );
  });

export default ProjectClusterPanelContentComponent;
